<template>
  <div class="gallery app-page-wrapper absolute" data-cy="gallery">
    <div class="w-full h-full relative flex flex-col items-center">
      <gallery-menu is-sub-menu-active />

      <section
        v-if="collections"
        class="w-full h-full overflow-hidden safe-area bg-cover flex"
        :style="{
          backgroundImage: 'url(' + pathImages + 'gallery/BG_FULLSCREEN.avif)',
        }"
      >
        <div
          class="main-wrapper h-full flex justify-center items-start relative main-gallery-content-wrapper"
        >
          <gallery-sub-header class="gallery-subheader">
            <span class="uppercase">
              {{ $t('gallery.completed') }}
            </span>

            <div>
              <span class="text-texts-standard-important font-bold">{{
                collectionsCompleted
              }}</span>
              <span>/{{ collections.length }}</span>
            </div>
          </gallery-sub-header>

          <app-scrollbar width="100%" height="100%" scroll="y" slice="y" class="flex mb-5">
            <div class="w-full flex flex-wrap gap-7 mt-5 ml-14 mr-8 content-start">
              <gallery-collection-item
                v-for="(collection, index) in collections"
                :key="index"
                :collection="collection"
              />
            </div>
          </app-scrollbar>
        </div>
      </section>

      <component-loading :is-loading="!collections" />
    </div>
  </div>
</template>

<script lang="ts">
import { pathImages } from '@/globalVariables'
import { defineComponent } from 'vue'
import GalleryCollectionItem from '../../components/Gallery/GalleryCollectionItem.vue'
import AppScrollbar from '../../components/GlobalComponents/AppScrollbar.vue'
import GalleryMenu from '@/components/Gallery/GalleryMenu.vue'
import GallerySubHeader from '@/components/Gallery/GallerySubHeader.vue'
import { mapState, mapActions } from 'pinia'
import { useGalleryCollectionsStore } from '@/store/pinia/gallery/collectionsStore'
import { useGalleryConverterStore } from '@/store/pinia/gallery/converterStore'

interface ComponentData {
  pathImages: typeof pathImages
}

export default defineComponent({
  name: 'GalleryView',

  components: {
    GalleryCollectionItem,
    AppScrollbar,
    GalleryMenu,
    GallerySubHeader,
  },

  data(): ComponentData {
    return {
      pathImages,
    }
  },

  computed: {
    ...mapState(useGalleryCollectionsStore, ['collections', 'collectionsCompleted']),
  },

  async created(): Promise<void> {
    await this.loadConverterData()
    this.loadCollections()
  },

  methods: {
    ...mapActions(useGalleryCollectionsStore, ['loadCollections']),
    ...mapActions(useGalleryConverterStore, ['loadConverterData']),
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/views/gallery/gallery.scss';

.main-gallery-content-wrapper {
  padding-top: 5.5rem;
  padding-bottom: 1.375rem;

  .gallery-subheader {
    top: 0;
    left: 0rem;
  }
}
</style>
